import { hideScrollBar } from '@repo/ui/components/utilities';
import { QUERIES } from '@repo/ui/queries';
import styled from 'styled-components';

import { FlexRow } from 'styles/layouts';

export const BreadCrumbsContainer = styled.div`
  overflow-y: auto;
  padding: 20px 24px;
  width: 100%;
  margin: 0 auto;

  ${QUERIES.tabletAndUp} {
    padding: 20px 48px;
  }

  ${QUERIES.smallDesktopAndUp} {
    max-width: 1440px;
  }
`;

export const BreadCrumbsWrapper = styled(FlexRow)`
  gap: 12px;
  align-items: center;
  white-space: nowrap;
  overflow: auto;

  ${hideScrollBar}
`;

export const BreadCrumbElement = styled(FlexRow)`
  gap: 12px;
  align-items: center;
`;
